export const WAHA_SOCKET_MESSAGE_TYPE = 'waha_session_status' as const;

export type WahaSessionStatusSocketPayload = {
  sessionName: string;
  engineStatus: string;
  lastError?: string | null;
  connectedPhone?: string | null;
  displayName?: string | null;
  profilePhotoUrl?: string | null;
};

export type WahaSessionStatusSocketMessage = {
  type: typeof WAHA_SOCKET_MESSAGE_TYPE;
  payload: WahaSessionStatusSocketPayload;
};

export type ParsedWahaSocketMessage = {
  rawBody: string;
  sessionMessage: WahaSessionStatusSocketMessage | null;
  /** Booking / planning / table realtime on `branch:{code}` — legacy STOMP body shape. */
  isBookingRealtimeEvent: boolean;
  bookingRealtimeBody?: Record<string, unknown>;
};
